(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const groups=[...root.querySelectorAll('.k9n__group')];
    const menuButton=root.querySelector('.k9n__menu-toggle');
    const mobileMenu=root.querySelector('.k9n__mobile-menu');
    const mobile=root.querySelector('.k9n__mobile');
    let timer;
    const close=(except)=>groups.forEach(group=>{if(group!==except){group.querySelector('button').setAttribute('aria-expanded','false');group.querySelector('.k9n__dropdown').hidden=true;}});
    const open=(group)=>{clearTimeout(timer);close(group);group.querySelector('button').setAttribute('aria-expanded','true');group.querySelector('.k9n__dropdown').hidden=false;};
    groups.forEach(group=>{
      const button=group.querySelector('button'),panel=group.querySelector('.k9n__dropdown');
      group.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')open(group);});
      group.addEventListener('pointerleave',()=>{timer=setTimeout(()=>{if(!group.contains(document.activeElement))close();},160);});
      button.addEventListener('click',e=>{if(e.detail>0&&e.pointerType==='mouse'){open(group);}else if(panel.hidden){open(group);}else{close();}});
      group.addEventListener('focusout',e=>{if(!group.contains(e.relatedTarget))close();});
      button.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){e.preventDefault();open(group);panel.querySelector('a')?.focus();}});
    });
    const setMobile=(isOpen)=>{mobileMenu.open=isOpen;};
    mobile.addEventListener('click',e=>{if(e.target.closest('a'))setMobile(false);});
    // V371: the open mobile menu covers the page, so close it when keyboard focus moves past it.
    root.addEventListener('focusout',e=>{if(mobileMenu.open&&e.relatedTarget&&!root.contains(e.relatedTarget))setMobile(false);});
    root.addEventListener('keydown',e=>{if(e.key==='Escape'){const group=groups.find(g=>!g.querySelector('.k9n__dropdown').hidden);if(group){close();group.querySelector('button').focus();}if(mobileMenu.open){setMobile(false);menuButton.focus();}}});
    document.addEventListener('click',e=>{if(!root.contains(e.target)){close();setMobile(false);}});
    const breakpoint=window.matchMedia('(min-width:1101px)');
    const resetMenus=()=>{close();setMobile(false);};
    if(breakpoint.addEventListener)breakpoint.addEventListener('change',resetMenus);
    else if(breakpoint.addListener)breakpoint.addListener(resetMenus);
  }
  const initAll=()=>document.querySelectorAll('[data-k9-navigation]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

/* V377: keep the header cart count and its accessible name in sync when the cart page changes without a reload. */
(function () {
  function setCount(count) {
    document.querySelectorAll('.k9n__cart').forEach(function (link) {
      link.setAttribute('aria-label', 'Shopping cart, ' + count + (count === 1 ? ' item' : ' items'));
      var badge = link.querySelector('.k9n__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'k9n__count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }
  document.addEventListener('cart:updated', function (event) {
    try {
      var cart = event.detail && event.detail.cart;
      if (typeof cart === 'string') cart = JSON.parse(cart);
      if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
    } catch (e) { /* leave the count as rendered */ }
  });
})();
